<script>
  import { urlServeur } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;
  let salairesMoyens;
  let classParti = false;
  let flag = false;

  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api_employe/classement_salaires"
    );
    if (response.ok) {
      const res = await response.json();
      salairesMoyens = res.payload.sal_moyen;
      //console.log(res);
      return res.payload.employes;
    }
  };

  const flagMedian = (cde, sal_moyen) => {
    if (cde === "init") {
      flag = false;
      return "";
    } else {
      if (sal_moyen == 1 && flag == false) {
        flag = true;
        return true;
      } else {
        return false;
      }
    }
  };

  promise = fetchData();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <h6>Positionnement par rapport au sal.moyen</h6>
  <p class="remarque">(1) Salaire = salaire+primes+h.supp+avantages...</p>
  {#each Object.entries(elements) as [keyAnnee, tabEmployes]}
    <h7 class:info={flagMedian("init", 0)}>
      Salaire moyen(1) : {keyAnnee} = {salairesMoyens[keyAnnee]} €
    </h7>

    <table class="table table-sm">
      <thead>
        <tr>
          <td>N°</td>
          <td>Nom</td>
          <td>Sal.(An)</td>
          <td>Sal.(Mois)</td>
          <td>Tx/h</td>
        </tr>
      </thead>
      <tbody>
        {#each Object.entries(tabEmployes) as [nomEmploye, valeurEmployes], index}
          <tr
            class:parti={valeurEmployes.EM_PARTI_LE > "1970-01-01"
              ? true
              : false}
            class:median={flagMedian("test", valeurEmployes.SALAIRE_MOYEN)}
            ><td>{index + 1}</td>
            <td>{nomEmploye}</td>
            <td
              >{new Intl.NumberFormat("fr-FR").format(
                valeurEmployes.SA_SALAIRE
              )}</td
            >
            <td
              >{new Intl.NumberFormat("fr-FR").format(
                Math.round(valeurEmployes.SA_SALAIRE / 12)
              )}</td
            >
            <td
              >{new Intl.NumberFormat("fr-FR").format(
                Math.round(valeurEmployes.SA_SALAIRE / 12 / 151.67, 2)
              )}</td
            >
          </tr>
        {/each}
      </tbody>
    </table>
  {/each}
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .parti {
    color: rgb(143, 146, 148);
    font-style: italic;
    text-decoration: line-through;
  }
  .median {
    background-color: rgb(194, 225, 246);
  }
  .info {
    /** class bidon, utilliser pour mettre un test svelte*/
  }
  .remarque {
    font-size: 0.75em;
    color: grey;
    font-style: italic;
  }
</style>
